import { useState } from 'react';

export type NgSwitchProps = {
  value?: boolean;
  onValueChanged?: (value: boolean) => void | Promise<void>;
  label?: string;
  id?: string;
  disabled?: boolean;
};

export function NgSwitch({ value, onValueChanged, label, id, disabled }: NgSwitchProps) {
  const [generatedId] = useState(() => `switch-${crypto.randomUUID()}`);
  const effectiveId = id ?? generatedId;

  return (
    <span className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id={effectiveId}
        checked={value ?? false}
        onChange={(event) => void onValueChanged?.(event.target.checked)}
        disabled={disabled}
      />
      <label className="form-check-label" htmlFor={effectiveId}>
        {label}
      </label>
    </span>
  );
}
